import { render, staticRenderFns } from "./ResourceSettings.vue?vue&type=template&id=c5565b38&scoped=true"
import script from "./ResourceSettings.vue?vue&type=script&lang=js"
export * from "./ResourceSettings.vue?vue&type=script&lang=js"
import style0 from "./ResourceSettings.vue?vue&type=style&index=0&id=c5565b38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5565b38",
  null
  
)

export default component.exports